import { defineComponent } from 'vue';
import { ValidationObserver } from 'vee-validate';

export default defineComponent({
  props: {
    username: { type: String, required: true },
    password: { type: String, required: true },
  },
  data() {
    return {
      u: this.username,
      p: this.password,
    };
  },
  computed: {
    // eslint-disable-next-line vue/no-unused-properties
    copyrightYears(): string {
      const currentYear = new Date().getFullYear();
      return `2006 - ${currentYear}`;
    },
  },
  watch: {
    u() {
      this.$emit('update:username', this.u);
    },
    p() {
      this.$emit('update:password', this.p);
    },
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    async login() {
      const isValid = await (this.$refs.observer as InstanceType<typeof ValidationObserver>).validate();
      if (!isValid) { return; }

      this.$emit('login');
    },
  },
});
